import { assertUnreachable, isNotDefined } from '@sgme/fp';

import { Awaiting } from '@/App/tiles/ForwardAccumulator/parts/PriceSummary/Awaiting.tsx';
import { NotPriceable } from '@/App/tiles/ForwardAccumulator/parts/PriceSummary/NotPriceable.tsx';
import { Pricing } from '@/App/tiles/ForwardAccumulator/parts/PriceSummary/Pricing/index.tsx';
import { StreamingError } from '@/App/tiles/ForwardAccumulator/parts/PriceSummary/StreamingError.tsx';
import {
  useForwardAccumulatorSelector,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { getForwardAccumulatorQuote, selectForwardAccumulatorRfsStatus } from '@/store/forwardAccumulator/selectors.ts';

export const PriceSummary = () => (
  <div style={{ height: '100px', maxWidth: '323px' }} data-e2e="price-summary">
    <PriceSummaryContent />
  </div>
);

function PriceSummaryContent() {
  const tileId = useForwardAccumulatorTileId();
  const { rfsStatus, hasQuote } = useForwardAccumulatorSelector((accumulator) => ({
    rfsStatus: selectForwardAccumulatorRfsStatus(accumulator),
    hasQuote: getForwardAccumulatorQuote(accumulator) !== undefined,
  }));

  if (isNotDefined(rfsStatus)) {
    return null;
  }

  switch (rfsStatus) {
    case 'NOT_PRICEABLE':
      return <NotPriceable />;
    case 'PRICEABLE': {
      if (hasQuote) {
        return <Pricing tileId={tileId} />;
      }
      return <NotPriceable />;
    }
    case 'AWAITING_INDICATIVE':
      return <Awaiting forceTradeable={false} />;
    case 'AWAITING_EXECUTABLE':
      return <Awaiting forceTradeable={true} />;
    case 'STREAMING_INDICATIVE':
      return <Pricing tileId={tileId} />;
    case 'STREAMING_EXECUTABLE':
      return <Pricing tileId={tileId} isExecutable />;
    case 'ERROR':
    case 'BYPASSABLE_ERROR':
      return <StreamingError />;
    default:
      assertUnreachable(rfsStatus, `Unknown price status: ${rfsStatus}`);
  }
}
